import {
  SET_DATA_SOURCE,
  SET_WORKPLACE_TYPES,
  SET_FOOD_SERVICE,
  SET_BENEFITS,
  SET_PARKING_OPTIONS,
  SET_WORKTRIP_TYPES,
} from './constants';
import { Map, List } from 'immutable';
import { IDatasource } from '../types/datasource';
import { IWorkplaceType } from '@/types/workplace';
import { IFoodService } from '@/types/foodService';
import { IBenefit } from '@/types/benefit';
import { IParking } from '@/types/parking';
import { IWorkTripType } from '@/types/workTripType';

const initialState = Map({
  list: List([]),
  workplaceTypes: List([]),
  benefits: List([]),
  foodService: List([]),
  parkingOptions: List([]),
  workTripTypes: List([]),
});

export default function (state = initialState, action: any) {
  switch (action.type) {
    case SET_DATA_SOURCE:
      return state.set('list', action.datasource as List<IDatasource>);

    case SET_WORKPLACE_TYPES:
      return state.set('workplaceTypes', action.workplaceTypes as List<IWorkplaceType>);

    case SET_FOOD_SERVICE:
      return state.set('foodService', action.foodService as List<IFoodService>);

    case SET_BENEFITS:
      return state.set('benefits', action.benefits as List<IBenefit>);

    case SET_PARKING_OPTIONS:
      return state.set('parkingOptions', action.parkingOptions as List<IParking>);

    case SET_WORKTRIP_TYPES:
      return state.set('workTripTypes', action.workTripTypes as List<IWorkTripType>);

    default:
      return state;
  }
}
